import template from './commercial-area-range.jade';
import validation from '../../../services/validation';

export default angular
    .module('cian.addForm.commercialAreaRange', [])
    .directive('cianAfAboutObjectCommercialAreaRange', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['$scope', 'deviceService', function($scope, deviceService) {
            this.isMobile = deviceService.isMobile;
            this.areaMax = 1e7;
            this.areaMin = 0;

            // если задано значение полю "Площадь до" и это значение больше равно значения поля "Площадь от" тогда значение "Поле до" максимум для поля "Площадь от" иначе глобальный максимум для этого типа поля
            this.getMaxForMinArea = () => angular.isDefined(this.ad.maxArea) && this.ad.maxArea >= this.ad.minArea ? this.ad.maxArea : this.areaMax;
            this.getMinForMaxArea = () => angular.isDefined(this.ad.minArea) && this.ad.minArea >= this.ad.maxArea ? this.ad.minArea : this.areaMin;

            $scope.$watchGroup([() => this.ad.maxArea, () => this.ad.minArea], ([newMaxForMinArea, newMinForMaxArea]) => {
                this.maxForMinArea = this.getMaxForMinArea();
                this.minForMaxArea = this.getMinForMaxArea();
            });

            this.isFieldRequired = () => !(this.ad.minArea > 0 || this.ad.maxArea > 0);

            this.validationMin = validation(this.form, 'minArea', {
                parse: 'Введите число',
                required: 'Укажите минимальную площадь',
                min: 'Площадь должна быть больше 0',
                max: 'Допустимо не более 7 символов',
            });

            this.validationMax = validation(this.form, 'maxArea', {
                parse: 'Введите число',
                required: 'Укажите максимальную площадь',
                min: 'Площадь должна быть больше или равна минимальной площади',
                max: 'Допустимо не более 7 символов',
            });

            this.setFocus = () => {
                this.focusInput = true;
                this.form.maxArea.$touched = false;
                this.form.minArea.$touched = false;
            };

            this.setBlur = () => {
                this.focusInput = false;
                this.form.maxArea.$touched = true;
                this.form.minArea.$touched = true;
            };

            this.areaComplexValidationInvalid = () => {
                return !this.focusInput && (this.validationMin.invalid() || this.validationMax.invalid() || this.ad.maxArea === 0);
            };

            this.areaComplexValidationMessage = () => {
                const bothRequired = this.form && this.form.maxArea && this.form.maxArea.$error.required && this.form.minArea.$error.required;
                let message;
                if (this.areaComplexValidationInvalid() && bothRequired) {
                    message = 'Укажите площадь';
                }
                else if (this.ad.maxArea === 0) {
                    message = 'Площадь должна быть больше 0';
                }
                else if (this.validationMin.invalid()) {
                    message = this.validationMin.message();
                }
                else {
                    message = this.validationMax.message();
                }
                return message;
            };
        }],
        controllerAs: 'commercialAreaRange',
        template,
    }))
    .name;
